import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomeView.vue'
import WageCalendar from '../views/WageCalendar.vue'
import LoginView from '../views/LoginView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/WageCalendar',
    name: 'WageCalendar',
    component: WageCalendar
  },
  {
    path: '/LoginView',
    name: 'LoginView',
    component: LoginView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
